import { jsx as _jsx } from "react/jsx-runtime";
import { NumberInput } from '@bos/ui';
import { getNumber } from '@pbk/get-number';
import { useController } from 'react-hook-form';
export const NumberField = ({ control, name, registerOptions, ...appNumberInputProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const handleChange = (e) => {
        const newValue = e.target.value;
        if (!newValue || newValue.length <= 0) {
            field.onChange('');
            return;
        }
        const num = getNumber(newValue);
        field.onChange(num);
    };
    const controlledValue = field.value ?? '';
    return (_jsx(NumberInput, { ...field, ...appNumberInputProps, value: controlledValue, error: fieldState.error?.message, onChange: handleChange }));
};
